import { createRouter, createWebHistory } from "vue-router";
import LandingPage from "../views/LandingPage.vue";
import AboutPage from "../views/AboutPage.vue";
import LoginPage from "@/views/LoginPage.vue";
import LoginPageRegisterEvent from "@/views/LoginPage.vue";
import LoginPageRegisterTournament from "@/views/LoginPage.vue";
import GuestSignupPage from "@/views/GuestSignupPage.vue";
import SignupPage from "@/views/SignupPage.vue";
import MembersInfoPage from "@/views/MembersInfoPage.vue";
import FormsApplication from "@/views/FormsApplication.vue";
import OurGuest from "@/views/OurGuest.vue";
import ClubPolicy from "@/views/ClubPolicy.vue";
import MediaGalleryPage from "@/views/MediaGalleryPage.vue";
import BookCourt from "@/views/BookCourt.vue";
import BookCompetition from "@/views/BookCompetition.vue";
import TounamentsView from "@/views/TounamentsView.vue";
import ProgramOverview from "@/views/ProgramOverview.vue";
import SocialEventPage from "@/views/SocialEventPage.vue";
//import SettingsView from "@/views/Dashboard/ApplicationsPage.vue";
import DashboardLayout from "@/Layouts/DashboardLayout.vue";
import DashboardHome from "@/views/Dashboard/DashboardHome.vue";
import SetupForm from "@/views/Dashboard/SetupForm.vue";

//DASHBOARD ITEMS
import SiteBannerList from "@/views/Dashboard/SiteBannerList.vue";
import SiteBannerSetup from "@/views/Dashboard/SiteBannerSetup.vue";
import ClubHighlightList from "@/views/Dashboard/ClubHighlightList.vue";
import ClubHighlightSetup from "@/views/Dashboard/ClubHighlightSetup.vue";
import ClubHighlightSetupExt from "@/views/Dashboard/ClubHighlightSetupExt.vue";
import ClubHighlightExtList from "@/views/Dashboard/ClubHighlightExtList.vue";
import ApplicationsPage from "@/views/Dashboard/ApplicationsPage.vue";
import SponsorPage from "@/views/Dashboard/SponsorPage.vue";
//import ExecutivePage from "@/views/Dashboard/ExecutivePage.vue";
import BookingPage from "@/views/Dashboard/BookingPage.vue";
import PaymentPage from "@/views/Dashboard/PaymentPage.vue";
import SocialEventsListPage from "@/views/Dashboard/SocialEventsListPage.vue";
import EventSetupPage from "@/views/Dashboard/EventSetupPage.vue";
import ProgramOverviewSetup from "@/views/Dashboard/ProgramOverviewSetup.vue";
import ProgramOverviewList from "@/views/Dashboard/ProgramOverviewList.vue";
import MediaGallerySetup from "@/views/Dashboard/MediaGallerySetup.vue";
import MediaGalleryList from "@/views/Dashboard/MediaGalleryList.vue";
import AboutPageList from "@/views/Dashboard/AboutPageList.vue";
import AboutSetupPage from "@/views/Dashboard/AboutSetupPage.vue";
import GalleryPhotoSetup from "@/views/Dashboard/GalleryPhotoSetup.vue";
import GalleryPhotoList from "@/views/Dashboard/GalleryPhotoList.vue";
import GuestList from "@/views/Dashboard/GuestList.vue";
import GuestSetup from "@/views/Dashboard/GuestSetup.vue";
import GuestEdit from "@/views/Dashboard/GuestEdit.vue";
import PolicyList from "@/views/Dashboard/PolicyList.vue";
import PolicySetup from "@/views/Dashboard/PolicySetup.vue";
import PolicyEdit from "@/views/Dashboard/PolicyEdit.vue";
import MembershipInfoContactUs from "@/views/Dashboard/MembershipInfoContactUs.vue";
import EventLists from "@/views/Dashboard/EventLists.vue";
import EventSetup from "@/views/Dashboard/EventSetup.vue";
import EventSetupEdit from "@/views/Dashboard/EventSetupEdit.vue";
import MembersPage from "@/views/Dashboard/MembersPage.vue";
import MyApplications from "@/views/Dashboard/MyApplications.vue";
import MyPayments from "@/views/Dashboard/MyPayments.vue";
import FeesList from "@/views/Dashboard/FeesList.vue";
import FeesSetup from "@/views/Dashboard/FeesSetup.vue";
import GalleryPhotoEdit from "@/views/Dashboard/GalleryPhotoEdit.vue";
import SiteBannerEdit from "@/views/Dashboard/SiteBannerEdit.vue";
import ClubHighlightEdit from "@/views/Dashboard/ClubHighlightEdit.vue";
import ClubHighlightExtEdit from "@/views/Dashboard/ClubHighlightExtEdit.vue";
import EventSetupPageEdit from "@/views/Dashboard/EventSetupPageEdit.vue";
import ProgramOverviewEdit from "@/views/Dashboard/ProgramOverviewEdit.vue";
import MediaGalleryEdit from "@/views/Dashboard/MediaGalleryEdit.vue";
import FeesEdit from "@/views/Dashboard/FeesEdit.vue";
import AboutEdit from "@/views/Dashboard/AboutEdit.vue";
import CoacheSetup from "@/views/Dashboard/CoacheSetup.vue";
import CoacheList from "@/views/Dashboard/CoacheList.vue";
import CoacheEdit from "@/views/Dashboard/CoacheEdit.vue";
import AdvertApproval from "@/views/Dashboard/AdvertApproval.vue";
import LogoSetup from "@/views/Dashboard/LogoSetup.vue";
import LogoList from "@/views/Dashboard/LogoList.vue";
import LogoEdit from "@/views/Dashboard/LogoEdit.vue";
import CategorySetup from "@/views/Dashboard/CategorySetup.vue";
import CategoryList from "@/views/Dashboard/CategoryList.vue";
import CategorySetupEdit from "@/views/Dashboard/CategorySetupEdit.vue";
import CourtBookingPage from "@/views/CourtBookingPage.vue";
import ExecutiveMemberPage from "@/views/Dashboard/ExecutiveMemberPage.vue";
import CourtSetup from "@/views/Dashboard/CourtSetup.vue";
import CourtLists from "@/views/Dashboard/CourtLists.vue";
import CourtEdit from "@/views/Dashboard/CourtEdit.vue";
import SportSectionList from "@/views/Dashboard/SportSectionList.vue";
import SportSection from "@/views/Dashboard/SportSection.vue";
import DocumentUpload from "@/views/Dashboard/DocumentUpload.vue";
import DocumentEdit from "@/views/Dashboard/DocumentEdit.vue";
import DocumentList from "@/views/Dashboard/DocumentList.vue";
import BrochureEdit from "@/views/Dashboard/BrochureEdit.vue";
import BrochureList from "@/views/Dashboard/BrochureList.vue";
import BrochureUpload from "@/views/Dashboard/BrochureUpload.vue";
import SportSectionEdit from "@/views/Dashboard/SportSectionEdit.vue";
import SportSectionDetail from "@/views/SportSectionDetail.vue";
import ValueEdit from "@/views/Dashboard/ValueEdit.vue";
import ValueList from "@/views/Dashboard/ValueList.vue";
import ValueSetup from "@/views/Dashboard/ValueSetup.vue";
import AboutContactUs from "@/views/Dashboard/AboutContactUs.vue";
import NewsletterPage from "@/views/Dashboard/NewsletterPage.vue";
import PasswordReset from "@/views/PasswordReset.vue";
import OtpPage from "@/views/OtpPage.vue";
import CreatePassword from "@/views/CreatePassword.vue";
import ProfilePage from "@/views/Dashboard/ProfilePage.vue";
import FaqEdit from "@/views/Dashboard/FaqEdit.vue";
import FaqList from "@/views/Dashboard/FaqList.vue";
import FaqPage from "@/views/Dashboard/FaqPage.vue";
import BannerEdit from "@/views/Dashboard/BannerEdit.vue";
import BannerList from "@/views/Dashboard/BannerList.vue";
import BannerSetup from "@/views/Dashboard/BannerSetup.vue";
import PrivacyPolicy from "@/views/Dashboard/PrivacyPolicy.vue";
import PrivacyPolicyEdit from "@/views/Dashboard/PrivacyPolicyEdit.vue";
import PrivacyPolicyList from "@/views/Dashboard/PrivacyPolicyList.vue";
import LegalPage from "@/views/Dashboard/LegalPage.vue";
import LegalList from "@/views/Dashboard/LegalList.vue";
import LegalEdit from "@/views/Dashboard/LegalEdit.vue";
import LegalHomePage from "@/views/LegalHomePage.vue";
import PrivacyPolicyPage from "@/views/PrivacyPolicyPage.vue";
import PhotoGallery from "@/views/PhotoGallery.vue";
import PhotoGallerySetup from "@/views/Dashboard/PhotoGallerySetup.vue";
import PhotoGalleryEdit from "@/views/Dashboard/PhotoGalleryEdit.vue";
import PhotoGalleryList from "@/views/Dashboard/PhotoGalleryList.vue";
import PhotoGalleryDetails from "@/views/PhotoGalleryDetails.vue";
import AdvertLists from "@/views/Dashboard/AdvertLists.vue";
import AdvertSetup from "@/views/Dashboard/AdvertSetup.vue";
import EventParticipants from "@/views/Dashboard/EventParticipants.vue";
import UserPayment from "@/views/Dashboard/UserPayment.vue";
import TournamentSetup from "@/views/Dashboard/TournamentSetup.vue";
import TournamentList from "@/views/Dashboard/TournamentList.vue";
import TournamentEdit from "@/views/Dashboard/TournamentEdit.vue";
import TournamentParticipant from "@/views/Dashboard/TournamentParticipant.vue";
import TermsAndConditions from "@/views/Dashboard/TermsAndConditions.vue";
import TermsAndConditionsEdit from "@/views/Dashboard/TermsAndConditionsEdit.vue";
import TermsAndConditionsList from "@/views/Dashboard/TermsAndConditionsList.vue";
import TermsAndConditionsPage from "@/views/TermsAndConditionsPage.vue";
import CourtScheduleSetup from "@/views/Dashboard/CourtScheduleSetup.vue";
import CourtScheduleList from "@/views/Dashboard/CourtScheduleList.vue";
import CourtScheduleEdit from "@/views/Dashboard/CourtScheduleEdit.vue";
import MyBookingPage from "@/views/Dashboard/MyBookingPage.vue";
import AllMediaPage from "@/views/AllMediaPage.vue";
import ClubSetup from "@/views/Dashboard/ClubSetup.vue";
import ClubEdit from "@/views/Dashboard/ClubEdit.vue";
import ClubList from "@/views/Dashboard/ClubList.vue";
import AdvertEdit from "@/views/Dashboard/AdvertEdit.vue";
import ClubEventTournamentType from "@/views/Dashboard/ClubEventTournamentType.vue";
import ClubEventTournamentTypeEdit from "@/views/Dashboard/ClubEventTournamentTypeEdit.vue";
import ClubEventTournamentTypeList from "@/views/Dashboard/ClubEventTournamentTypeList.vue";
import ClubEventTeamSetup from "@/views/Dashboard/ClubEventTeamSetup.vue";
import ClubEventTeamEdit from "@/views/Dashboard/ClubEventTeamEdit.vue";
import ClubEventTeamList from "@/views/Dashboard/ClubEventTeamList.vue";
import LogsPage from "@/views/Dashboard/LogsPage.vue";
import MemberUpdatePage from "@/views/Dashboard/MemberUpdatePage.vue";

const routes = [
  {
    path: "/",
    name: "LandingPage",
    component: LandingPage,
  },
  {
    path: "/about-us",
    name: "AboutPage",
    component: AboutPage,
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/login/:event",
    name: "LoginPageRegisterEvent",
    component: LoginPageRegisterEvent,
  },
  {
    path: "/login/:tournament",
    name: "LoginPageRegisterTournament",
    component: LoginPageRegisterTournament,
  },
  {
    path: "/reset-password",
    name: "PasswordReset",
    component: PasswordReset,
  },
  {
    path: "/otp",
    name: "OtpPage",
    component: OtpPage,
  },
  {
    path: "/create-password/:ref",
    name: "CreatePassword",
    component: CreatePassword,
  },
  {
    path: "/guest-register",
    name: "GuestSignupPage",
    component: GuestSignupPage,
  },
  {
    path: "/register",
    name: "SignupPage",
    component: SignupPage,
  },
  {
    path: "/membership-info",
    name: "MembersInfoPage",
    component: MembersInfoPage,
  },
  {
    path: "/application-forms",
    name: "FormsApplication",
    component: FormsApplication,
  },
  {
    path: "/guest-info",
    name: "OurGuest",
    component: OurGuest,
  },
  {
    path: "/club-policy",
    name: "ClubPolicy",
    component: ClubPolicy,
  },
  {
    path: "/media-gallery/:title",
    name: "MediaGalleryPage",
    component: MediaGalleryPage,
  },

  {
    path: "/all-media/:date?",
    name: "AllMediaPage",
    component: AllMediaPage,
  },  
  
  {
    path: "/book-a-court",
    name: "BookCourt",
    component: BookCourt,
  },
  {
    path: "/tournaments",
    name: "BookCompetition",
    component: BookCompetition,
  },
  {
    path: "/more-tournaments",
    name: "TounamentsView",
    component: TounamentsView,
  },
  {
    path: "/program-overview",
    name: "ProgramOverviews",
    component: ProgramOverview,
  },
  {
    path: "/social-event",
    name: "SocialEventPage",
    component: SocialEventPage,
  },
  {
    path: "/legal",
    name: "LegalHomePage",
    component: LegalHomePage,
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicyPage",
    component: PrivacyPolicyPage,
  },
  {
    path: "/terms-and-conditions",
    name: "TermsAndConditionsPage",
    component: TermsAndConditionsPage,
  },
  {
    path: "/court-booking",
    name: "CourtBookingPage",
    component: CourtBookingPage,
  },
  
  {
    path: "/photo-gallery/:date?",
    name: "PhotoGallery",
    component: PhotoGallery,
  },
  {
    path: "/photo-gallery/:title",
    name: "PhotoGalleryDetails",
    component: PhotoGalleryDetails,
  },
  {
    path: "/more-detail/:title",
    name: "SportSectionDetail",
    component: SportSectionDetail,
  },
  {
    path: "/dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "DashboardHome",
        component: DashboardHome,
      },
      {
        path: "/applications",
        name: "ApplicationsPage",
        component: ApplicationsPage,
      },
      {
        path: "/create-members",
        name: "MemberUpdatePage",
        component: MemberUpdatePage,
      },
      {
        path: "/applications-s",
        name: "SponsorPage",
        component: SponsorPage,
      },
      {
        path: "/applications-e",
        name: "ExecutiveMemberPage",
        component: ExecutiveMemberPage,
      },
      {
        path: "/bookings",
        name: "BookingPage",
        component: BookingPage,
      },
      {
        path: "/payments",
        name: "PaymentPage",
        component: PaymentPage,
      },
      {
        path: "/settings-form",
        name: "SetupForm",
        component: SetupForm,
      },
      {
        path: "/site-banner",
        name: "SiteBannerList",
        component: SiteBannerList,
      },
      {
        path: "/site-banner-setup",
        name: "SiteBannerSetup",
        component: SiteBannerSetup,
      },
      {
        path: "/club-highlight",
        name: "ClubHighlightList",
        component: ClubHighlightList,
      },
      {
        path: "/club-highlight-setup",
        name: "ClubHighlightSetup",
        component: ClubHighlightSetup,
      },
      {
        path: "/club-highlight-ext-setup",
        name: "ClubHighlightSetupExt",
        component: ClubHighlightSetupExt,
      },
      {
        path: "/club-highlight-ext",
        name: "ClubHighlightExtList",
        component: ClubHighlightExtList,
      },
      {
        path: "/social-events-lists",
        name: "SocialEventsListPage",
        component: SocialEventsListPage,
      },
      {
        path: "/create-events",
        name: "EventSetupPage",
        component: EventSetupPage,
      },
      {
        path: "/program-overview-lists",
        name: "ProgramOverviewList",
        component: ProgramOverviewList,
      },
      {
        path: "/create-program-overview",
        name: "ProgramOverviewSetup",
        component: ProgramOverviewSetup,
      },
      {
        path: "/media-gallery-lists",
        name: "MediaGalleryList",
        component: MediaGalleryList,
      },
      {
        path: "/media-gallery-setup",
        name: "MediaGallerySetup",
        component: MediaGallerySetup,
      },
      {
        path: "/about-list",
        name: "AboutPageList",
        component: AboutPageList,
      },
      {
        path: "/about-setup",
        name: "AboutSetupPage",
        component: AboutSetupPage,
      },
      {
        path: "/gallery-photo-list",
        name: "GalleryPhotoList",
        component: GalleryPhotoList,
      },
      {
        path: "/gallery-photo-setup",
        name: "GalleryPhotoSetup",
        component: GalleryPhotoSetup,
      },
      {
        path: "/guest-list",
        name: "GuestList",
        component: GuestList,
      },
      {
        path: "/guest-setup",
        name: "GuestSetup",
        component: GuestSetup,
      },
      {
        path: "/edit-guest/:id",
        name: "GuestEdit",
        component: GuestEdit,
      },
      {
        path: "/policy-list",
        name: "PolicyList",
        component: PolicyList,
      },
      {
        path: "/policy-setup",
        name: "PolicySetup",
        component: PolicySetup,
      },
      {
        path: "/edit-policy/:id",
        name: "PolicyEdit",
        component: PolicyEdit,
      },
      {
        path: "/contact-info",
        name: "MembershipInfoContactUs",
        component: MembershipInfoContactUs,
      },
      {
        path: "/event-lists",
        name: "EventLists",
        component: EventLists,
      },
      {
        path: "/event-setup",
        name: "EventSetup",
        component: EventSetup,
      },
      {
        path: "/event-edit/:id",
        name: "EventSetupEdit",
        component: EventSetupEdit,
      },
      {
        path: "/advert-edit/:id",
        name: "AdvertEdit",
        component: AdvertEdit,
      },
      {
        path: "/advert-approval",
        name: "AdvertApproval",
        component: AdvertApproval,
      },
      {
        path: "/members",
        name: "MembersPage",
        component: MembersPage,
      },
      {
        path: "/myapplications",
        name: "MyApplications",
        component: MyApplications,
      },
      {
        path: "/listpayments",
        name: "MyPayments",
        component: MyPayments,
      },
      {
        path: "/club-list",
        name: "ClubList",
        component: ClubList,
      },
      {
        path: "/club-setup",
        name: "ClubSetup",
        component: ClubSetup,
      },
      {
        path: "/edit-club/:id",
        name: "ClubEdit",
        component: ClubEdit,
      },

      {
        path: "/club-event-tournament-list",
        name: "ClubEventTournamentTypeList",
        component: ClubEventTournamentTypeList,
      },
      {
        path: "/club-event-tournament-setup",
        name: "ClubEventTournamentType",
        component: ClubEventTournamentType,
      },
      {
        path: "/edit-club-event-tournament/:id",
        name: "ClubEventTournamentTypeEdit",
        component: ClubEventTournamentTypeEdit,
      },

      {
        path: "/club-event-team-list",
        name: "ClubEventTeamList",
        component: ClubEventTeamList,
      },
      {
        path: "/club-event-team-setup",
        name: "ClubEventTeamSetup",
        component: ClubEventTeamSetup,
      },
      {
        path: "/edit-club-event-team/:id",
        name: "ClubEventTeamEdit",
        component: ClubEventTeamEdit,
      },

      {
        path: "/fees-list",
        name: "FeesList",
        component: FeesList,
      },
      {
        path: "/fees-setup",
        name: "FeesSetup",
        component: FeesSetup,
      },
      {
        path: "/edit-fees/:id",
        name: "FeesEdit",
        component: FeesEdit,
      },
      {
        path: "/edit-gallery-photo/:id",
        name: "GalleryPhotoEdit",
        component: GalleryPhotoEdit,
      },
      {
        path: "/edit-banner/:id",
        name: "SiteBannerEdit",
        component: SiteBannerEdit,
      },
      {
        path: "/edit-clubhighlight/:id",
        name: "ClubHighlightEdit",
        component: ClubHighlightEdit,
      },
      {
        path: "/edit-clubhighlight_ext/:id",
        name: "ClubHighlightExtEdit",
        component: ClubHighlightExtEdit,
      },
      {
        path: "/edit-social-event/:id",
        name: "EventSetupPageEdit",
        component: EventSetupPageEdit,
      },
      {
        path: "/edit-program-overview/:id",
        name: "ProgramOverviewEdit",
        component: ProgramOverviewEdit,
      },
      {
        path: "/edit-media-gallery/:id",
        name: "MediaGalleryEdit",
        component: MediaGalleryEdit,
      },
     
      {
        path: "/edit-about/:id",
        name: "AboutEdit",
        component: AboutEdit,
      },
      {
        path: "/coaches-setup",
        name: "CoacheSetup",
        component: CoacheSetup,
      },
      {
        path: "/coaches-list",
        name: "CoacheList",
        component: CoacheList,
      },
      {
        path: "/coaches-edit/:id",
        name: "CoacheEdit",
        component: CoacheEdit,
      },
      {
        path: "/logo-setup",
        name: "LogoSetup",
        component: LogoSetup,
      },
      {
        path: "/logo-lists",
        name: "LogoList",
        component: LogoList,
      },
      {
        path: "/edit-logo/:id",
        name: "LogoEdit",
        component: LogoEdit,
      },
      {
        path: "/category-setup",
        name: "CategorySetup",
        component: CategorySetup,
      },
      {
        path: "/category-list",
        name: "CategoryList",
        component: CategoryList,
      },
      {
        path: "/edit-category/:id",
        name: "CategorySetupEdit",
        component: CategorySetupEdit,
      },

      {
        path: "/court-setup",
        name: "CourtSetup",
        component: CourtSetup,
      },
      {
        path: "/court-lists",
        name: "CourtLists",
        component: CourtLists,
      },
      {
        path: "/edit-court/:id",
        name: "CourtEdit",
        component: CourtEdit,
      },
      {
        path: "/sport-section-lists",
        name: "SportSectionList",
        component: SportSectionList,
      },
      {
        path: "/edit-sport-section/:id",
        name: "SportSectionEdit",
        component: SportSectionEdit,
      },
      {
        path: "/sport-section-setup",
        name: "SportSection",
        component: SportSection,
      },
      {
        path: "/document-setup",
        name: "DocumentUpload",
        component: DocumentUpload,
      },
      {
        path: "/edit-document/:id",
        name: "DocumentEdit",
        component: DocumentEdit,
      },
      {
        path: "/document-list",
        name: "DocumentList",
        component: DocumentList,
      },

      {
        path: "/brochure-setup",
        name: "BrochureUpload",
        component: BrochureUpload,
      },
      {
        path: "/edit-brochure/:id",
        name: "BrochureEdit",
        component: BrochureEdit,
      },
      {
        path: "/brochure-list",
        name: "BrochureList",
        component: BrochureList,
      },

      {
        path: "/our-values-setup",
        name: "ValueSetup",
        component: ValueSetup,
      },
      {
        path: "/edit-our-values/:id",
        name: "ValueEdit",
        component: ValueEdit,
      },
      {
        path: "/our-values-list",
        name: "ValueList",
        component: ValueList,
      },
      {
        path: "/contact-us",
        name: "AboutContactUs",
        component: AboutContactUs,
      },
      {
        path: "/subscribe-list",
        name: "NewsletterPage",
        component: NewsletterPage,
      },
      {
        path: "/myprofile",
        name: "ProfilePage",
        component: ProfilePage,
      },

      {
        path: "/faq",
        name: "FaqPage",
        component: FaqPage,
      },
      {
        path: "/edit-faq/:id",
        name: "FaqEdit",
        component: FaqEdit,
      },
      {
        path: "/faq-list",
        name: "FaqList",
        component: FaqList,
      },

      {
        path: "/website-banner",
        name: "BannerSetup",
        component: BannerSetup,
      },
      {
        path: "/edit-website-banner/:id",
        name: "BannerEdit",
        component: BannerEdit,
      },
      {
        path: "/website-banner-list",
        name: "BannerList",
        component: BannerList,
      },

      {
        path: "/privacy-policy-setup",
        name: "PrivacyPolicy",
        component: PrivacyPolicy,
      },
      {
        path: "/edit-privacy-policy/:id",
        name: "PrivacyPolicyEdit",
        component: PrivacyPolicyEdit,
      },
      {
        path: "/privacy-policy-list",
        name: "PrivacyPolicyList",
        component: PrivacyPolicyList,
      },

      {
        path: "/legal-setup",
        name: "LegalPage",
        component: LegalPage,
      },
      {
        path: "/edit-legal/:id",
        name: "LegalEdit",
        component: LegalEdit,
      },
      {
        path: "/legal-list",
        name: "LegalList",
        component: LegalList,
      },

      {
        path: "/photo-gallery-lists",
        name: "PhotoGalleryList",
        component: PhotoGalleryList,
      },
      {
        path: "/photo-gallery-setup",
        name: "PhotoGallerySetup",
        component: PhotoGallerySetup,
      },
      {
        path: "/edit-photo-gallery/:id",
        name: "PhotoGalleryEdit",
        component: PhotoGalleryEdit,
      },
      {
        path: "/advert-lists",
        name: "AdvertLists",
        component: AdvertLists,
      },
      {
        path: "/advert-setup",
        name: "AdvertSetup",
        component: AdvertSetup,
      },
      {
        path: "/event-participants",
        name: "EventParticipants",
        component: EventParticipants,
      },
      {
        path: "/user-payments",
        name: "UserPayment",
        component: UserPayment,
      },
      {
        path: "/create-tournament",
        name: "TournamentSetup",
        component: TournamentSetup,
      },
      {
        path: "/list-tournament",
        name: "TournamentList",
        component: TournamentList,
      },
      {
        path: "/edit-tournament/:id",
        name: "TournamentEdit",
        component: TournamentEdit,
      },
      {
        path: "/tournament-participants",
        name: "TournamentParticipant",
        component: TournamentParticipant,
      },
      {
        path: "/terms-conditions-setup",
        name: "TermsAndConditions",
        component: TermsAndConditions,
      },
      {
        path: "/edit-terms-conditions/:id",
        name: "TermsAndConditionsEdit",
        component: TermsAndConditionsEdit,
      },
      {
        path: "/terms-conditions-list",
        name: "TermsAndConditionsList",
        component: TermsAndConditionsList,
      },
      {
        path: "/schedule-court",
        name: "CourtScheduleSetup",
        component: CourtScheduleSetup,
      },
      {
        path: "/schedule-court-list",
        name: "CourtScheduleList",
        component: CourtScheduleList,
      },
      {
        path: "/schedule-court-edit/:id",
        name: "CourtScheduleEdit",
        component: CourtScheduleEdit,
      },
      {
        path: "/my-bookings",
        name: "MyBookingPage",
        component: MyBookingPage,
      },
      {
        path: "/logs",
        name: "LogsPage",
        component: LogsPage,
      },
      
    ],
  },
 
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  }
});

export default router;
